import {Plugin} from "prosemirror-state";
import {Decoration, DecorationSet} from "prosemirror-view";
import {isParagraphEmpty} from "../helper/nodeSelection";

export const trailingNode = new Plugin({
    view: () => ({
        update: view => {
            const {state} = view;
            const lastNode = state.tr.doc.lastChild;

            if (isParagraphEmpty(lastNode, state.schema)) {
                return;
            }

            const {doc, tr} = state;
            const transaction = tr.insert(doc.content.size, state.schema.nodes.paragraph.create());
            view.dispatch(transaction);
        },
    }),
    props: {
        decorations: state => {
            const {doc} = state;
            const decorations = [];
            const lastNode = doc.lastChild;
            state.doc.descendants((node, pos) => {
                if (node !== lastNode) {
                    return;
                }

                decorations.push(Decoration.node(pos, pos + node.nodeSize, {
                        class: 'empty-trailing-node'
                    })
                );
            });

            return DecorationSet.create(doc, decorations);
        },
    }
});